import { render } from "./PublicStatement.vue?vue&type=template&id=a40e0dea"
import script from "./PublicStatement.vue?vue&type=script&lang=js"
export * from "./PublicStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__